import React from "react";
import {
  HeaderConfig,
  IntroContentConfig,
  IntroThemeConfig,
  appleAppStoreLink,
  appliedConfig,
  googlePlayStoreLink,
} from "../config/commonConfig";
const AboutUs = () => {
  return (
    <section
      id="about"
      className={
        "section " +
        (appliedConfig.appliedHeader === HeaderConfig.SideHeaderDark ||
        appliedConfig.appliedHeader === HeaderConfig.SideHeaderLight
          ? "px-lg-4 "
          : " ")
      }
    >
      <div
        className={
          "container " +
          (appliedConfig.appliedIntro === IntroThemeConfig.Intro1 &&
          appliedConfig.appliedIntroContent === IntroContentConfig.Image
            ? "pt-5 "
            : " ")
        }
      >
        <h2 className="text-9 fw-600 text-center">Sobre o App</h2>
        <hr className="heading-separator-line bg-primary opacity-10 mx-auto" />
        <p className="lead text-center mb-4">
          Chega de confusão na hora de montar os times.
        </p>
        <div className="row">
          <div className="col-lg-6 text-center">
            {" "}
            <img className="img-fluid" src="images/about-app.png" alt="" />{" "}
          </div>
          <div className="col-lg-6 text-center text-lg-start">
            <h2 className="text-6 mb-3 mt-4">
              Design intuitivo e um sistema inteligente de balanceamento
            </h2>
            <p>
              Pelada+ é o app ideal para quem quer equilibrar os times na hora da pelada com os amigos. Esqueça o par ou ímpar, discussões ou escolhas injustas. Com poucos toques, você cadastra os jogadores, define os critérios e o Pelada+ monta os times mais equilibrados para um jogo justo e divertido.
            </p>
            <p>
              Fácil de usar, rápido e prático — tudo para sua resenha começar bem antes do apito inicial.
            </p>
            <div className="d-inline-flex pt-2">
              {" "}
              <a
                className="me-4"
                href={appleAppStoreLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img className="img-fluid" src="images/app-store.png" alt="" />
              </a>
              <a
                href={googlePlayStoreLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="img-fluid"
                  src="images/google-play-store.png"
                  alt=""
                />
              </a>{" "}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
